import React, { useRef, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import InputField from "@_common/InputRuleFeild";
import Header from "@components/common/Header";
import { getValue } from "@utils/lodash";
import SimpleReactValidator from "simple-react-validator";
import _ from "lodash";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import "./roles-details.scss";
import { formatText } from "@_common/format-text";
import NoAccessPage from "@components/common/NoAccess";
import Loader from "@components/common/Loader";
import {
	adminReportsShowHideColumns,
	runReport,
} from "@services/reports.service";
import {
	adminGetCountriesListManagement,
	adminGetLegislationManagementByQuery,
	adminGetLegislationManagementRuleByQuery,
	adminGetListManagementGroupCode,
	adminGetListManagementStateCategoryListByQuery,
	adminGetStatesListManagementString,
} from "@services/list-management.service";
import { QueryRequestHelper } from "@_common/query-request-helper";
import {
	clientGetFunction,
	clientGetLocation,
} from "@services/location.service";
import { handleDownloadOnClick } from "@_common/downloadfile";
import { adminGetGroups } from "@services/groups.service";
import moment from "moment";
import { sanitizeInput } from "@_common/dompurify";

interface IReportLicenseAddProps {}

const ReportVendorAuditAdd: React.FunctionComponent<IReportLicenseAddProps> = (
	props: any
) => {
	let params = useParams();
	let navigate = useNavigate();
	/* -------------------------------------------------------------------------- */
	/*                               UseState Section                             */
	/* -------------------------------------------------------------------------- */
	const simpleValidator = useRef(new SimpleReactValidator());
	const [, forceUpdate] = useState(0);

	const [isLoading, setIsLoading] = React.useState(true);
	const [activeTab, setActiveTab] = useState("1");
	const [allColumnList, setAllColumnList] = useState([]);
	const [hiddenColumns, setHiddenColumns] = useState<any>([]);
	const [shownColumns, setShownColumns] = useState<any>([]);
	const [report_name, setReportName] = useState("");
	const [report_description, setReportDescription] = useState("");
	const [report_type] = useState("VENDOR_AUDIT");
	//additional filters
	const [documentTypeList, setDocumentTypeList] = useState([]);
	const [complianceTypeList, setComplianceTypeList] = useState([]);
	const [taskTypeList, setTaskTypeList] = useState([]);
	const [frequencyList, setFrequencyList] = useState([]);
	const [businessTypeList, setBusinessTypeList] = useState([]);
	const [regionList, setRegionList] = useState([]);
	const [eventList, setEventList] = useState([]);
	const [subEventList, setSubEventList] = useState([]);
	const [prohibitiveList, setProhibitiveList] = useState([]);
	const [levelList, setLevelList] = useState([]);
	const [impactList, setImpactList] = useState([]);
	//dependency filter
	const [countryList, setCountryList] = useState([]);
	const [states, setStates] = useState([]);
	const [categoryOfLawList, setCategoryOfLawList] = useState([]);
	const [legislationList, setLegislationList] = useState([]);
	const [ruleList, setRuleList] = useState([]);
	const [locations, setLocations] = useState([]);
	const [functions, setFunctions] = useState([]);
	const [groups, setGroups] = useState([]);

	const [dateFilters, setDateFilters] = useState<any>([]);
	const [dependencyFilters, setDependencyFilters] = useState<any>([
		{
			key: "country",
			value: [
				{
					id: 101,
					name: "India",
					label: "India",
					value: "India",
				},
			],
		},
		{ key: "state", value: [] },
		{ key: "category_of_law", value: [] },
		{ key: "legislation", value: [] },
		{ key: "rule", value: [] },
		{ key: "location", value: [] },
		// { key: 'function', value: [] },
		// { key: 'group', value: [] },
	]);
	const [listFilters, setListFilters] = useState<any>([]);
	const [submitLoading, setSubmitLoading] = useState(false);

	const [reportTypeList] = useState([
		{ value: "VENDOR_AUDIT", label: "Vendor Audit" },
		{ value: "PE_COMPLIANCE", label: "Pe Compliance" },
		{ value: "LICENSE", label: "License" },
	]);
	const [dateList] = useState([
		{ value: "THIS_WEEK", label: "This Week" },
		{ value: "THIS_QUATER", label: "This Quarter" },
		{ value: "THIS_MONTH", label: "This Month" },
		{ value: "THIS_YEAR", label: "This Year" },
		{ value: "PREVIOUS_WEEK", label: "Previous Week" },
		{ value: "PREVIOUS_MONTH", label: "Previous Month" },
		{ value: "PREVIOUS_QUATER", label: "Previous Quarter" },
		{ value: "PREVIOUS_YEAR", label: "Previous Year" },
		{ value: "TODAY", label: "Today" },
		{ value: "YESTERDAY", label: "Yesterday" },
		{ value: "CUSTOM", label: "Custom" },
	]);
	const [dependencyDropdowns] = useState([
		{ value: "country", label: "Country" },
		{ value: "state", label: "State" },
		{ value: "legislation", label: "Legislation" },
		{ value: "rule", label: "Rule" },
		{ value: "category_of_law", label: "Category of Law" },
		{ value: "location", label: "Location" },
		// { value: 'function', label: 'Function' },
		// { value: 'group', label: 'Group' },
	]);
	const [listManagementDropdowns] = useState([
		{ value: "document_type", label: "Document Type" },
		// { value: "compliance_type", label: "Compliance Type" },
		{ value: "task_type", label: "Task Type" },
		{ value: "frequency", label: "Frequency" },
		{ value: "business_type", label: "Business Type" },
		{ value: "region", label: "Region" },
		{ value: "events", label: "Events" },
		{ value: "sub_events", label: "Sub Events" },
		{ value: "prohibitive", label: "Prohibitive" },
		{ value: "level", label: "Level" },
		{ value: "impact", label: "Impact" },
		{ value: "upload_status", label: "Upload Status" },
		{ value: "audit_status", label: "Audit Status" },
	]);
	const [dateDropdowns] = useState([
		{ value: "created_date", label: "Created Date" },
		{ value: "uploaded_date", label: "Uploaded Date" },
		{ value: "release_date", label: "Release Date" },
		{ value: "expiry_date", label: "Expiry Date" },
		{ value: "remittance_date", label: "Remittance Date" },
		{ value: "audited_at", label: "Audit At" },
	]);
	const [auditStatusList] = useState([
		{ value: "PENDING_AUDIT", label: "Pending Audit" },
		{ value: "NOT_SUBMITTED", label: "Not Submitted" },
		{ value: "COMPLIED", label: "Complied" },
		{ value: "NON_COMPLIED", label: "Non Complied" },
		{ value: "NOT_APPLICABLE", label: "Not Applicable" },
		{ value: "PARTIALLY_COMPLIED", label: "Partially Complied" },
		{ value: "SEND_BACK_TO_VENDOR", label: "Send Back To Vendor" },
	]);
	const [uploadStatusList] = useState([
		{ value: "UPLOADED", label: "Uploaded" },
		{ value: "NOT_UPLOADED", label: "Not Uploaded" },
	]);
	/* -------------------------------------------------------------------------- */
	/*                               UseEffect Section                            */
	/* -------------------------------------------------------------------------- */

	useEffect(() => {
		if (props.permissionAPITriggered) {
			setIsLoading(false);
			// tab 1 APIs
			getCountriesList();
			getAllListManagementDropdownItems();
			// tab 2 APIs
			getColumnData();
			getAllLocations();
			getAllGroups();
		}
	}, [props.permissionAPITriggered]);
	/* -------------------------------------------------------------------------- */
	/*                               API Section                                  */
	/* -------------------------------------------------------------------------- */
	const getAllListManagementDropdownItems = async () => {
		try {
			let prohibitive = await adminGetListManagementGroupCode("prohibitive");
			let task_type = await adminGetListManagementGroupCode("task-type");
			let level = await adminGetListManagementGroupCode("level");
			let impact = await adminGetListManagementGroupCode("impact");
			let sub_events = await adminGetListManagementGroupCode("sub-events");
			let events = await adminGetListManagementGroupCode("events");
			// let compliance_type = await adminGetListManagementGroupCode(
			// 	"compliance-type"
			// );
			let document_type = await adminGetListManagementGroupCode(
				"document-type"
			);
			let business_type = await adminGetListManagementGroupCode(
				"business-type"
			);
			let frequency = await adminGetListManagementGroupCode("frequency");
			let regionList = await adminGetListManagementGroupCode("region-type");

			if (prohibitive) {
				let list =
					getValue(prohibitive, `data.listItems.length`, 0) > 0
						? getValue(prohibitive, `data.listItems`, []).filter(
								(item: object) => getValue(item, `is_active`, false)
						  )
						: [];
				setProhibitiveList(
					list.map((item: object) => ({
						id: getValue(item, `id`, ""),
						is_active: getValue(item, `is_active`, ""),
						text: getValue(item, `text`, ""),
						value: getValue(item, `text`, ""),
						label: getValue(item, `text`, ""),
					}))
				);
			}
			if (task_type) {
				let list =
					getValue(task_type, `data.listItems.length`, 0) > 0
						? getValue(task_type, `data.listItems`, []).filter((item: object) =>
								getValue(item, `is_active`, false)
						  )
						: [];
				setTaskTypeList(
					list.map((item: object) => ({
						id: getValue(item, `id`, ""),
						is_active: getValue(item, `is_active`, ""),
						text: getValue(item, `text`, ""),
						value: getValue(item, `text`, ""),
						label: getValue(item, `text`, ""),
					}))
				);
			}
			if (level) {
				let list =
					getValue(level, `data.listItems.length`, 0) > 0
						? getValue(level, `data.listItems`, []).filter((item: object) =>
								getValue(item, `is_active`, false)
						  )
						: [];
				setLevelList(
					list.map((item: object) => ({
						id: getValue(item, `id`, ""),
						is_active: getValue(item, `is_active`, ""),
						text: getValue(item, `text`, ""),
						value: getValue(item, `text`, ""),
						label: getValue(item, `text`, ""),
					}))
				);
			}
			if (impact) {
				let list =
					getValue(impact, `data.listItems.length`, 0) > 0
						? getValue(impact, `data.listItems`, []).filter((item: object) =>
								getValue(item, `is_active`, false)
						  )
						: [];
				setImpactList(
					list.map((item: object) => ({
						id: getValue(item, `id`, ""),
						is_active: getValue(item, `is_active`, ""),
						text: getValue(item, `text`, ""),
						value: getValue(item, `text`, ""),
						label: getValue(item, `text`, ""),
					}))
				);
			}
			if (sub_events) {
				let list =
					getValue(sub_events, `data.listItems.length`, 0) > 0
						? getValue(sub_events, `data.listItems`, []).filter(
								(item: object) => getValue(item, `is_active`, false)
						  )
						: [];
				setSubEventList(
					list.map((item: object) => ({
						id: getValue(item, `id`, ""),
						is_active: getValue(item, `is_active`, ""),
						text: getValue(item, `text`, ""),
						value: getValue(item, `text`, ""),
						label: getValue(item, `text`, ""),
					}))
				);
			}
			if (events) {
				let list =
					getValue(events, `data.listItems.length`, 0) > 0
						? getValue(events, `data.listItems`, []).filter((item: object) =>
								getValue(item, `is_active`, false)
						  )
						: [];
				setEventList(
					list.map((item: object) => ({
						id: getValue(item, `id`, ""),
						is_active: getValue(item, `is_active`, ""),
						text: getValue(item, `text`, ""),
						value: getValue(item, `text`, ""),
						label: getValue(item, `text`, ""),
					}))
				);
			}
			// if (compliance_type) {
			// 	let list =
			// 		getValue(compliance_type, `data.listItems.length`, 0) > 0
			// 			? getValue(compliance_type, `data.listItems`, []).filter(
			// 					(item: object) => getValue(item, `is_active`, false)
			// 			  )
			// 			: [];
			// 	setComplianceTypeList(
			// 		list.map((item: object) => ({
			// 			id: getValue(item, `id`, ""),
			// 			is_active: getValue(item, `is_active`, ""),
			// 			text: getValue(item, `text`, ""),
			// 			value: getValue(item, `text`, ""),
			// 			label: getValue(item, `text`, ""),
			// 		}))
			// 	);
			// }
			if (document_type) {
				let list =
					getValue(document_type, `data.listItems.length`, 0) > 0
						? getValue(document_type, `data.listItems`, []).filter(
								(item: object) => getValue(item, `is_active`, false)
						  )
						: [];
				setDocumentTypeList(
					list.map((item: object) => ({
						id: getValue(item, `id`, ""),
						is_active: getValue(item, `is_active`, ""),
						text: getValue(item, `text`, ""),
						value: getValue(item, `text`, ""),
						label: getValue(item, `text`, ""),
					}))
				);
			}
			if (business_type) {
				let list =
					getValue(business_type, `data.listItems.length`, 0) > 0
						? getValue(business_type, `data.listItems`, []).filter(
								(item: object) => getValue(item, `is_active`, false)
						  )
						: [];
				setBusinessTypeList(
					list.map((item: object) => ({
						id: getValue(item, `id`, ""),
						is_active: getValue(item, `is_active`, ""),
						text: getValue(item, `text`, ""),
						value: getValue(item, `text`, ""),
						label: getValue(item, `text`, ""),
					}))
				);
			}
			if (frequency) {
				let list =
					getValue(frequency, `data.listItems.length`, 0) > 0
						? getValue(frequency, `data.listItems`, []).filter((item: object) =>
								getValue(item, `is_active`, false)
						  )
						: [];
				setFrequencyList(
					list.map((item: object) => ({
						id: getValue(item, `id`, ""),
						is_active: getValue(item, `is_active`, ""),
						text: getValue(item, `text`, ""),
						value: getValue(item, `text`, ""),
						label: getValue(item, `text`, ""),
					}))
				);
			}
			if (regionList) {
				let list =
					getValue(regionList, `data.listItems.length`, 0) > 0
						? getValue(regionList, `data.listItems`, []).filter(
								(item: object) => getValue(item, `is_active`, false)
						  )
						: [];
				setRegionList(
					list.map((item: object) => ({
						id: getValue(item, `id`, ""),
						is_active: getValue(item, `is_active`, ""),
						text: getValue(item, `text`, ""),
						value: getValue(item, `text`, ""),
						label: getValue(item, `text`, ""),
					}))
				);
			}
		} catch (error) {}
	};
	const getColumnData = async () => {
		try {
			let resp = await adminReportsShowHideColumns();
			if (resp) {
				let list: any = Object.entries(getValue(resp, `data.vendor_audit`, {}));
				let listOfItems = list.map((item: any) => ({
					key: getValue(item, `[${0}]`, ""),
					value: getValue(item, `[${1}].key`, ""),
					is_default_shown: getValue(item, `[${1}].is_default_shown`, ""),
					is_mandatory: getValue(item, `[${1}].is_mandatory`, ""),
				}));
				setAllColumnList(listOfItems);
				let hidden =
					getValue(listOfItems, `length`, 0) > 0
						? listOfItems.filter((item: any) => !item.is_default_shown)
						: [];
				let shown =
					getValue(listOfItems, `length`, 0) > 0
						? listOfItems.filter((item: any) => item.is_default_shown)
						: [];
				setHiddenColumns(
					getValue(hidden, `length`, 0) > 0
						? hidden.map((item: any) => item)
						: []
				);
				let sortShown = shown.sort(function (x: any, y: any) {
					return !x.is_mandatory ? 0 : x ? -1 : 1;
				});
				setShownColumns(
					getValue(sortShown, `length`, 0) > 0
						? sortShown.map((item: any) => item)
						: []
				);
			}
		} catch (error) {}
	};
	console.log(shownColumns, "--shownColumns--")
	const handleSubmit = async () => {
		const formValid = simpleValidator.current.allValid();
		if (!formValid) {
			simpleValidator.current.showMessages();
			forceUpdate(1);
		} else {
			let array: any = [];
			let arr: any = array.concat(dependencyFilters, listFilters);
			let main: any = [];
			for (let i = 0; i < getValue(arr, `length`, 0); i++) {
				if (getValue(arr, `[${i}].value.length`, 0) > 0) {
					main.push({
						key: arr[i].key,
						value:
							getValue(arr, `[${i}].value.length`, 0) > 0
								? getValue(arr, `[${i}].value`, [])
										.map((item: any) => item.id)
										.join(",")
								: "",
					});
				}
			}
			let dates: any = [];
			let date =
				getValue(dateFilters, `length`, 0) > 0
					? dateFilters.map((item: any) => {
							if (item.value === "CUSTOM") {
								dates.push({
									key: item.key,
									value: item.value,
									custom_from_date: getValue(item, `custom_from_date`, "")
										? moment(getValue(item, `custom_from_date`, "")).format(
												"YYYY-MM-DD"
										  )
										: null,
									custom_to_date: getValue(item, `custom_to_date`, "")
										? moment(getValue(item, `custom_to_date`, "")).format(
												"YYYY-MM-DD"
										  )
										: null,
								});
							} else {
								dates.push({
									key: item.key,
									value: item.value,
								});
							}
					  })
					: [];
			let reportFilters = main.concat(dates);
			try {
				setSubmitLoading(true);
				let resp = await runReport({
					report_type: report_type,
					report_name: report_name,
					report_description: report_description,
					// is_scheduled:true,
					// columns_showm:
					// 	shownColumns.length > 0
					// 		? shownColumns
					// 				.map((item: object) => getValue(item, `key`, ""))
					// 				.join(",")
					// 		: "",

					columns_showm:
					shownColumns
					.filter((item:any) => getValue(item, "key", "") !== "id")  // Exclude items with key "id"
					.map((item:any) => getValue(item, "key", ""))
					.join(","),
					report_filter: reportFilters,
				});
				if (resp) {
					setSubmitLoading(false);
					// handleDownloadOnClick(
					// 	getValue(resp, `data.report_url`, ""),
					// 	getValue(resp, `data.report_name`, "")
					// );
					navigate(`/report/vendor-audit`);
				} else {
					setSubmitLoading(false);
				}
			} catch (error) {
				setSubmitLoading(false);
			}
		}
	};
	const getCountriesList = async () => {
		try {
			let resp = await adminGetCountriesListManagement();
			if (resp) {
				setCountryList(
					getValue(resp, `data.countries`, []).map((item: object) => ({
						...item,
						value: getValue(item, `name`, ""),
						label: getValue(item, `name`, ""),
					}))
				);
				if (getValue(resp, `data.countries.length`, 0) > 0) {
					let queryRequest = QueryRequestHelper({
						country: [101],
					});
					getStatesList(queryRequest);
				}
			} else {
			}
		} catch (error) {}
	};
	const getStatesList = async (countryId: any) => {
		try {
			let resp = await adminGetStatesListManagementString(countryId);
			if (resp) {
				setStates(
					getValue(resp, `data.states`, []).map((item: object) => ({
						...item,
						value: getValue(item, `name`, ""),
						label: getValue(item, `name`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};
	const getAlreadyAttachedData = async (state_id: string) => {
		if (state_id)
			try {
				let resp = await adminGetListManagementStateCategoryListByQuery(
					state_id
				);
				if (resp) {
					setCategoryOfLawList(
						getValue(resp, `data.stateCategoryOfLaw`, []).map(
							(item: object) => ({
								// ...item,
								id: getValue(item, `category_of_law.id`, ""),
								value: getValue(item, `category_of_law.text`, ""),
								label: getValue(item, `category_of_law.text`, ""),
							})
						)
					);
				} else {
				}
			} catch (error) {}
	};
	const getLegislationList = async (stateId: string) => {
		if (stateId)
			try {
				let resp = await adminGetLegislationManagementByQuery(stateId);
				if (resp) {
					setLegislationList(
						getValue(resp, `data.legislations`, []).map((item: object) => ({
							...item,
							value: getValue(item, `legislation_name`, ""),
							label: getValue(item, `legislation_name`, ""),
						}))
					);
				} else {
				}
			} catch (error) {}
	};
	const getLegislationRuleList = async (legislation_id: string) => {
		if (legislation_id)
			try {
				let resp = await adminGetLegislationManagementRuleByQuery(
					legislation_id
				);
				if (resp) {
					setRuleList(
						getValue(resp, `data.legislationRules`, []).map((item: object) => ({
							...item,
							value: getValue(item, `rule_name`, ""),
							label: getValue(item, `rule_name`, ""),
						}))
					);
				} else {
				}
			} catch (error) {}
	};
	const getAllGroups = async () => {
		let payload: any = {
			page_no: 1,
			page_size: 100,
		};
		let queryRequest = QueryRequestHelper(payload);
		try {
			let resp = await adminGetGroups(queryRequest);
			if (resp) {
				let list =
					getValue(resp, `data.groups.length`, 0) > 0
						? getValue(resp, `data.groups`, []).filter((item: object) =>
								getValue(item, `is_active`, false)
						  )
						: [];
				setGroups(
					list.map((item: object) => ({
						...item,
						status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
						value: getValue(item, `group_name`, ""),
						label: getValue(item, `group_name`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};
	const getAllLocations = async () => {
		let payload: any = {
			page_no: 1,
			page_size: 100,
		};
		let queryRequest = QueryRequestHelper(payload);
		let locations = await clientGetLocation(queryRequest);
		if (locations) {
			setLocations(
				getValue(locations, `data.locations`, []).map((item: object) => ({
					value: getValue(item, `location_name`, ""),
					label: getValue(item, `location_name`, ""),
					id: getValue(item, `id`, ""),
				}))
			);
		}
	};
	const getLocationFunctions = async (ids: any) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());

		let payload: any = {
			page_no: params.page_no ? parseInt(params.page_no) : 1,
			page_size: 100,
			search_text: params.search_text,
			sort_by: params.sort_by,
			location_ids: ids,
		};
		let queryRequest = QueryRequestHelper(payload);
		try {
			let resp = await clientGetFunction(queryRequest);
			if (resp) {
				setFunctions(
					getValue(resp, `data.functions`, []).map((item: object) => ({
						value: getValue(item, `function_name`, ""),
						label: getValue(item, `function_name`, ""),
						id: getValue(item, `id`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};
	/* -------------------------------------------------------------------------- */
	/*                               Onchange section                             */
	/* -------------------------------------------------------------------------- */

	const handleAddRemoveItems = (value: object, type: string) => {
		if (type === "show") {
			hiddenColumns.push(value);
			let filtered = shownColumns.filter(
				(item: object) =>
					getValue(item, `key`, "") !== getValue(value, `key`, "")
			);
			setShownColumns(filtered);
		} else {
			shownColumns.push(value);
			let filtered = hiddenColumns.filter(
				(item: object) =>
					getValue(item, `key`, "") !== getValue(value, `key`, "")
			);
			setHiddenColumns(filtered);
		}
	};
	const addDropdown = (type: string) => {
		let obj: any = {
			key: "",
			value: "",
		};
		if (type === "date") {
			dateFilters.push(obj);
			setDateFilters([...dateFilters]);
		}
		if (type === "list") {
			listFilters.push(obj);
			setListFilters([...listFilters]);
		}
	};
	const removeDropdown = (type: string, index: number) => {
		if (type === "date") {
			let list =
				dateFilters.length > 0 &&
				dateFilters.filter((_item: any, i: number) => i !== index);
			setDateFilters(list);
		}
		if (type === "list") {
			let list =
				listFilters.length > 0 &&
				listFilters.filter((_item: any, i: number) => i !== index);
			setListFilters(list);
		}
	};
	const handleChangeKey = (
		status: string,
		type: string,
		value: string,
		i: number
	) => {
		if (status === "key") {
			if (type === "date") {
				let checkAlreadyExisted = dateFilters.filter(
					(item: any) => item.key === value
				);
				if (getValue(checkAlreadyExisted, `length`, 0) === 0) {
					setDateFilters(
						dateFilters.map((x: any, index: number) => {
							if (index !== i) return x;
							return {
								...x,
								key: value ? value : "",
							};
						})
					);
				} else {
					toast.error("Already selected, Select different filter to continue");
				}
			}
			if (type === "list") {
				let checkAlreadyExisted = listFilters.filter(
					(item: any) => item.key === value
				);
				if (getValue(checkAlreadyExisted, `length`, 0) === 0) {
					setListFilters(
						listFilters.map((x: any, index: number) => {
							if (index !== i) return x;
							return {
								...x,
								key: value ? value : "",
							};
						})
					);
				} else {
					toast.error("Already selected, Select different filter to continue");
				}
			}
		} else if (status === "value") {
			if (type === "date") {
				setDateFilters(
					dateFilters.map((x: any, index: number) => {
						if (index !== i) return x;
						return {
							...x,
							value: value ? value : "",
						};
					})
				);
			}
			if (type === "list") {
				setListFilters(
					listFilters.map((x: any, index: number) => {
						if (index !== i) return x;
						return {
							...x,
							value: value ? value : "",
						};
					})
				);
			}
		} else {
			setDateFilters(
				dateFilters.map((x: any, index: number) => {
					if (index !== i) return x;
					return {
						...x,
						[status]: value ? value : null,
					};
				})
			);
		}
	};
	const handleChangeMultiSelectKey = (
		status: string,
		type: string,
		value: any,
		i: number
	) => {
		if (status === "key") {
			if (type === "list") {
				let checkAlreadyExisted = listFilters.filter(
					(item: any) => item.key === value
				);
				if (getValue(checkAlreadyExisted, `length`, 0) === 0) {
					setListFilters(
						listFilters.map((x: any, index: number) => {
							if (index !== i) return x;
							return {
								...x,
								key: value ? value : "",
							};
						})
					);
				} else {
					toast.error("Already selected, Select different filter to continue");
				}
			}
		}
		if (status === "value") {
			if (type === "list") {
				setListFilters(
					listFilters.map((x: any, index: number) => {
						if (index !== i) return x;
						return {
							...x,
							value: value ? value : [],
						};
					})
				);
			}
		}
	};
	const findListOptions = (value: string) => {
		switch (value) {
			case "document_type":
				return documentTypeList;
			// case "compliance_type":
			// 	return complianceTypeList;
			case "task_type":
				return taskTypeList;
			case "frequency":
				return frequencyList;
			case "business_type":
				return businessTypeList;
			case "region":
				return regionList;
			case "events":
				return eventList;
			case "sub_events":
				return subEventList;
			case "prohibitive":
				return prohibitiveList;
			case "level":
				return levelList;
			case "impact":
				return impactList;
			case "audit_status":
				return auditStatusList;
			case "upload_status":
				return uploadStatusList;

			case "country":
				return countryList;
			case "state":
				return states;
			case "category_of_law":
				return categoryOfLawList;
			case "legislation":
				return legislationList;
			case "rule":
				return ruleList;
			case "location":
				return locations;
			// case 'function':
			// 	return functions;
			// case 'group':
			// 	return groups;
			default:
				return [];
		}
	};
	const handleChangeDependencyMultiOptions = (
		key: string,
		value: any,
		i: number
	) => {
		setDependencyFilters(
			dependencyFilters.map((x: any, index: number) => {
				if (index !== i) return x;
				return {
					...x,
					value: value ? value : [],
				};
			})
		);
		handleMultiSelectOptions(key, value);
	};
	const handleMultiSelectOptions = (key: string, value: any) => {
		if (key === "country") {
			let queryRequest = QueryRequestHelper({
				country: value.map((item: object) => getValue(item, `id`, "")),
			});
			getStatesList(queryRequest);
		}
		if (key === "state") {
			let queryRequest = QueryRequestHelper({
				state_ids: value.map((item: object) => getValue(item, `id`, "")),
			});
			getAlreadyAttachedData(queryRequest);
			getLegislationList(queryRequest);
		}
		if (key === "legislation") {
			let queryRequest = QueryRequestHelper({
				legislation_ids: value.map((item: object) => getValue(item, `id`, "")),
			});
			getLegislationRuleList(queryRequest);
		}
		// if (key === "rule") {
		// }
		// if (key === "category_of_law") {
		// }
		if (key === "location") {
			let queryRequest = QueryRequestHelper({
				location_ids: value.map((item: object) => getValue(item, `id`, "")),
			});
			getLocationFunctions(
				value.map((item: object) => getValue(item, `id`, ""))
			);
		}
		// if (key === "function") {
		// }
		// if (key === "group") {
		// }
	};
	const tomorrowDate: any = moment().add(1, "days");
	let tomorrow: any = new Date(tomorrowDate);
	return (
		<>
			<Header />
			{!isLoading &&
			!getValue(props, `subTabPermissionList`, []).includes("report_analytics_vendor_audit") ? (
				<NoAccessPage />
			) : (
				<>
					<div className="user-details-wrapper user-details-wrapper__sticky">
						<div className="user-details-wrapper__header d-flex align-items-center justify-content-between">
							<div className="d-flex align-items-center">
								<NavLink
									to="/report/vendor-audit"
									className="user-details-wrapper__header-back-link"
								>
									<img src="/images/back-link.svg" className="img-fluid" />
								</NavLink>
								<div className="user-details-wrapper__add-user-title">Add</div>
							</div>
							{getValue(props, `permissions`, []).includes("update") && (
								<div className="user-details-wrapper__cta-btns">
									<NavLink to={`/report/vendor-audit`}>
										<button className="ascent-button ascent-button--header-buttons ascent-button--primary">
											Cancel
										</button>
									</NavLink>
									{submitLoading ? (
										<button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
											Please wait...
										</button>
									) : (
										<button
											className={`ascent-button ascent-button--header-buttons ascent-button--secondary`}
											onClick={handleSubmit}
										>
											Run Report
										</button>
									)}
								</div>
							)}
						</div>
					</div>

					<div className="rolls-wrapper pt-5 mt-5">
						<div className="rolls-wrapper__form-wrapper">
							{isLoading || !props.permissionAPITriggered ? (
								<Loader />
							) : (
								<div className="pt-5 pb-5">
									<div className="rolls-wrapper">
										<div className="rolls-wrapper__form">
											<div className="rolls-wrapper__form-group form-group">
												<label htmlFor="title" className="rolls-label">
													Report Name <span>*</span>
												</label>
												<InputField
													inputType="TEXT"
													placeholder="Enter Report Name"
													label="Report Name"
													className="form-control rolls-form-control"
													id="title"
													// validator={simpleValidator}
													value={report_name}
													onChange={(e: any) => setReportName(sanitizeInput(e.target.value))}
													validator={simpleValidator}
												/>
											</div>
											{/* <div className="rolls-wrapper__form-group form-group">
													<label htmlFor="title" className="rolls-label">
														Report Type <span>*</span>
													</label>
													<InputField
														inputType="INPUT_REACT_SELECT"
														placeholder="Enter Report Type"
														label="Report Type"
														className="form-control rolls-form-control"
														id="title"
														// validator={simpleValidator}
														options={reportTypeList}
														value={reportTypeList.filter(
															(item) => item.value === report_type
														)}
														onChange={(e: any) => setReportType(e.value)}
														validator={simpleValidator}
													/>
												</div> */}
										</div>
										<div className="rolls-wrapper__form-group form-group">
											<label htmlFor="description" className="rolls-label">
												Report Description <span>*</span>
											</label>
											<InputField
												inputType="TEXTAREA"
												// rows={5}
												placeholder="Enter Report Description"
												className="form-control"
												name="description"
												id="description"
												value={report_description}
												onChange={(e: any) =>
													setReportDescription(sanitizeInput(e.target.value))
												}
												label="Description"
												validator={simpleValidator}
											/>
										</div>
										<div className="rolls-wrapper__form-wrapper d-flex">
											<button
												onClick={() => setActiveTab("1")}
												className={`m-0 ascent-button ascent-button--header-buttons ${
													activeTab === "1"
														? "ascent-button--secondary"
														: "ascent-button--primary"
												}`}
											>
												Filter
											</button>
											<button
												onClick={() => setActiveTab("2")}
												className={`mt-0 margin-left-16 ascent-button ascent-button--header-buttons ${
													activeTab === "2"
														? "ascent-button--secondary"
														: "ascent-button--primary"
												}`}
											>
												Show / Hide Columns
											</button>
										</div>
										{activeTab === "1" && (
											<div className="pt-4">
												<div className="mb-5">
													<h4 className="medium-bold-font mb-2">
														Date Filters
													</h4>
													{getValue(dateFilters, `length`, 0) > 0 ? (
														dateFilters.map((item: any, index: number) => {
															return (
																<>
																	<div className="d-flex justify-content-between mb-3 align-items-center flex-gap-16px">
																		<InputField
																			inputType="INPUT_REACT_SELECT"
																			placeholder="Select Filter"
																			options={dateDropdowns}
																			value={dateDropdowns.filter(
																				(fil) =>
																					fil.value ===
																					getValue(item, `key`, "")
																			)}
																			customClass="w-100"
																			onChange={(e: any) =>
																				handleChangeKey(
																					"key",
																					"date",
																					getValue(e, `value`, ""),
																					index
																				)
																			}
																			isClear
																		/>
																		<InputField
																			inputType="INPUT_REACT_SELECT"
																			placeholder="Select Filter"
																			options={dateList}
																			value={dateList.filter(
																				(fil) =>
																					fil.value ===
																					getValue(item, `value`, "")
																			)}
																			onChange={(e: any) =>
																				handleChangeKey(
																					"value",
																					"date",
																					getValue(e, `value`, ""),
																					index
																				)
																			}
																			customClass="w-100"
																			isClear
																		/>

																		<div
																			onClick={() =>
																				removeDropdown("date", index)
																			}
																		>
																			<img
																				src="/images/close-red.svg"
																				width={24}
																				height={24}
																				className="img-fluid cursor-pointer"
																			/>
																		</div>
																	</div>
																	<div>
																		{getValue(item, `value`, "") ===
																			"CUSTOM" && (
																			<div className="d-flex w-100 flex-gap-16px">
																				<div className="flex-1">
																					<InputField
																						inputType={"DATETYPE-DOB"}
																						value={getValue(
																							item,
																							`custom_from_date`,
																							""
																						)}
																						className="form-control"
																						onChange={(e: any) =>
																							handleChangeKey(
																								"custom_from_date",
																								"date",
																								e,
																								index
																							)
																						}
																						// minDate={tomorrow}
																						placeholderText="Enter Custom From Date"
																					/>
																				</div>
																				<div className="flex-1">
																					<InputField
																						inputType={"DATETYPE-DOB"}
																						value={getValue(
																							item,
																							`custom_to_date`,
																							""
																						)}
																						className="form-control"
																						onChange={(e: any) =>
																							handleChangeKey(
																								"custom_to_date",
																								"date",
																								e,
																								index
																							)
																						}
																						minDate={getValue(
																							item,
																							`custom_from_date`,
																							""
																						)}
																						placeholderText="Enter Custom To Date"
																					/>
																				</div>
																				<div className="mx-1">&nbsp;</div>
																			</div>
																		)}
																	</div>
																</>
															);
														})
													) : (
														<p className="text-center mt-2 no-filter-selected">
															No Filter Selected, Please Add One
														</p>
													)}
													{dateFilters.length <= dateDropdowns.length - 1 && (
														<>
															<button
																onClick={() => addDropdown("date")}
																className="ascent-button ascent-button--primary ascent-button--header-buttons"
															>
																Add Filter
															</button>
														</>
													)}
												</div>

												<div className="mb-5">
													<h4 className="medium-bold-font mb-2">
														Additional Filters
													</h4>
													{getValue(listFilters, `length`, 0) > 0 ? (
														listFilters.map((item: any, index: number) => {
															return (
																<div className="d-flex justify-content-between mb-3 flex-gap-16px">
																	<InputField
																		inputType="INPUT_REACT_SELECT"
																		placeholder="Select Filter"
																		customClass="w-100"
																		options={listManagementDropdowns}
																		value={listManagementDropdowns.filter(
																			(fil) =>
																				fil.value === getValue(item, `key`, "")
																		)}
																		onChange={(e: any) =>
																			handleChangeKey(
																				"key",
																				"list",
																				getValue(e, `value`, ""),
																				index
																			)
																		}
																		isClear
																	/>
																	<InputField
																		inputType="INPUT_REACT_SELECT"
																		placeholder="Select Filter"
																		customClass="w-100"
																		options={findListOptions(
																			getValue(item, `key`, "")
																		)}
																		value={getValue(item, `value`, "")}
																		onChange={(e: any) =>
																			handleChangeMultiSelectKey(
																				"value",
																				"list",
																				e,
																				index
																			)
																		}
																		isClear
																		isMulti
																	/>
																	<div
																		onClick={() =>
																			removeDropdown("list", index)
																		}
																	>
																		<img
																			src="/images/close-red.svg"
																			width={24}
																			height={24}
																			className="img-fluid cursor-pointer"
																		/>
																	</div>
																</div>
															);
														})
													) : (
														<p className="text-center mt-2 no-filter-selected">
															No Filter Selected, Please Add One
														</p>
													)}
													{listFilters.length <=
														listManagementDropdowns.length - 1 && (
														<button
															onClick={() => addDropdown("list")}
															className="ascent-button ascent-button--primary ascent-button--header-buttons"
														>
															Add Filter
														</button>
													)}
												</div>

												<div>
													<h4 className="medium-bold-font mb-3">
														Dependency Filters
													</h4>

													{getValue(dependencyFilters, `length`, 0) > 0 ? (
														dependencyFilters.map(
															(item: any, index: number) => {
																return (
																	<div className="cursor-pointer mb-3">
																		<div className="user-details-wrapper__form-group form-group mb-3 d-flex align-items-center">
																			<h6 className="flex-1 normal-font user-details-wrapper__max-width-150px">
																				{formatText(getValue(item, `key`, ""))}
																			</h6>
																			<div className="flex-2">
																				<InputField
																					inputType="INPUT_REACT_SELECT"
																					placeholder="Enter Country"
																					className="form-control w-100"
																					name="country_id"
																					id="country_id"
																					options={findListOptions(
																						getValue(item, `key`, "")
																					)}
																					customClass="w-100"
																					value={getValue(item, `value`, "")}
																					onChange={(e: any) =>
																						handleChangeDependencyMultiOptions(
																							getValue(item, `key`, ""),
																							e,
																							index
																						)
																					}
																					label={formatText(
																						getValue(item, `key`, "")
																					)}
																					isMulti
																				/>
																			</div>
																		</div>
																	</div>
																);
															}
														)
													) : (
														<p className="text-center mt-2 no-filter-selected">
															No Filter Selected, Please Add One
														</p>
													)}
												</div>
											</div>
										)}
										{activeTab === "2" && (
											<>
												<div className="pe-compliance__show-hide-columns mt-4 mb-4">
													<div>
														<h6 className="normal-font mb-2">Columns Hidden</h6>
														<div className="pe-compliance__columns-hidden">
															{getValue(hiddenColumns, `length`, 0) > 0 ? (
																hiddenColumns.map((item: any) => {
																	return (
																		<>
																			<div
																				className="pe-compliance__columns-hidden-items d-flex justify-content-between align-items-center cursor-pointer transition"
																				onClick={() =>
																					handleAddRemoveItems(item, "hide")
																				}
																			>
																				{formatText(item.key)}
																				<div className="pe-compliance__columns-hidden-items-cta">
																					<img
																						src="/images/add-btn.svg"
																						width={24}
																						height={24}
																						className="img-fluid"
																					/>
																				</div>
																			</div>
																		</>
																	);
																})
															) : (
																<>
																	<div className="pe-compliance__columns-hidden-items d-flex justify-content-between align-items-center cursor-pointer transition text-center">
																		No Data Found
																	</div>
																</>
															)}
														</div>
													</div>
													<div className="">
														<h6 className="normal-font mb-2">Columns Shown</h6>
														<div className="pe-compliance__columns-shown">
															{getValue(shownColumns, `length`, 0) > 0 ? (
																shownColumns.map((item: any) => {
																	return (
																		<>
																			<div
																				className={`pe-compliance__columns-hidden-items pe-compliance__columns-hidden-items--shown d-flex align-items-center transition
																				${getValue(item, `is_mandatory`, false) ? "" : "justify-content-between"}`}
																			>
																				{formatText(item.key)}{" "}
																				{getValue(
																					item,
																					`is_mandatory`,
																					false
																				) && (
																					<span style={{ color: "red" }}>
																						*
																					</span>
																				)}
																				{!getValue(
																					item,
																					`is_mandatory`,
																					false
																				) && (
																					<div
																						className="pe-compliance__columns-hidden-items-cta"
																						onClick={() =>
																							handleAddRemoveItems(item, "show")
																						}
																					>
																						<img
																							src="/images/close-red.svg"
																							width={20}
																							height={20}
																							className="img-fluid cursor-pointer"
																						/>
																					</div>
																				)}
																			</div>
																		</>
																	);
																})
															) : (
																<>
																	<div className="pe-compliance__columns-hidden-items d-flex justify-content-between align-items-center cursor-pointer transition text-center">
																		No Data Found
																	</div>
																</>
															)}
														</div>
													</div>
												</div>
											</>
										)}
									</div>
								</div>
							)}
						</div>
					</div>
				</>
			)}
		</>
	);
};

export default ReportVendorAuditAdd;
